import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { useFormik, Form, FormikProvider } from 'formik';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { useNavigate } from 'react-router-dom';
// material
import { Stack, TextField, Fade, Container, FormGroup, FormControlLabel, Checkbox, InputLabel, Select, MenuItem, FormControl, Autocomplete } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { useAuth } from '../components/common/use-auth';
import { useTranslation } from 'react-i18next';

import Request from '../components/common/Request';
import {  Paths, GetAzurePath, AzurePaths } from '../components/common/Constants';

import {
    useParams
  } from "react-router-dom";
import Page from '../components/Page';
import MultiSelectAutoComplete from '../components/MultiSelectAutoComplete';

import { FormHelperText } from '@mui/material';
// ----------------------------------------------------------------------

export default function Notification() {
    const {t, i18n} = useTranslation();
        
    const navigate = useNavigate();
    
    const {user} = useAuth();
    const [sendTestMessage, setSendTestMessage] = useState(false);

    const [users, setUsers] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedUsersDefaultValue, setSelectedUsersDefaultValue] = useState([]);

    const [serverError, setServerError] = useState(null);
    const [serverMessage, setServerMessage] = useState(null);
    const [showServerMessage, setShowServerMessage] = useState(false);
    const [lastTimeout, setLastTimeout] = useState(null);

    const [autoCompleteValue, setAutoCompleteValue] = useState("");
    

    const RegisterSchema = Yup.object().shape({
        title: Yup.string().min(2, t("error_too_short")).max(50, t("error_too_long")).required(t("error_required")),//.required('Password is required'),
        body: Yup.string().min(2, t("error_too_short")).max(50, t("error_too_long")).required(t("error_required")),
    });




    const formik = useFormik({
        initialValues: {
            title : '',
            body : ''
        },
        validationSchema: RegisterSchema,
        onSubmit: async (values) => {

           // setServerError(null);
            console.log(values);

            var userIds =  autoCompleteValue.map( (usr) => { return usr.UserId; });
            if (!sendTestMessage)
                userIds = null;
                
            var response = await Request.Post( Paths.SendPushNotification, 
              { UserIds : userIds, 
                Title : values.title, 
                Body : values.body,
                Lang : destLang });

            if (response.statusCode != 200){
    
                console.log("serverError!!");
                setServerError(t("error_post_failed"));
            }
            else
            {
                setServerError(false);
                setServerMessage(t("notification_sent"));
            }
        
            setShowServerMessage(true);

            if (lastTimeout != null){
                clearTimeout(lastTimeout);
            }

            var timeout = setTimeout(() => {
              setShowServerMessage(false);
            }, 4000);

            setLastTimeout(timeout);

        }
    });
    const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

    const selectableLanguages = [ 
        { value : "all", name : "all" },
        { value  : "de", name : "de" },
        { value  : "en", name : "enAndRest" }];

    const [destLang, setDestLang] = useState(selectableLanguages[0].value);

    useEffect(async () =>{
    
        if (user != null){
            var result = await Request.Get(Paths.Users);
      
        
            if(result.ok){
                var data = result.data.Users;
                setUsers( data );
                setSelectedUsersDefaultValue(data.filter(p => p.UserId == user.UserId));
                setAutoCompleteValue(data.filter(p => p.UserId == user.UserId));
        
            }
        }


    }, [user]);


    console.log("users", users);



    if (users == null)
        return <div></div>;
    return (
        
        <Page title={t("notification_pagetitle")}>
            <Container>
                <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                       <Stack spacing={3}>
                       {/*   <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <TextField
                            fullWidth
                            label="First name"
                            {...getFieldProps('firstName')}
                            error={Boolean(touched.firstName && errors.firstName)}
                            helperText={touched.firstName && errors.firstName}
                            />

                            <TextField
                            fullWidth
                            label="Last name"
                            {...getFieldProps('lastName')}
                            error={Boolean(touched.lastName && errors.lastName)}
                            helperText={touched.lastName && errors.lastName}
                            />
                        </Stack> */}


              
                        <FormControl sx={{ m: 0, minWidth: 80, maxWidth: 200 }} >
                            {/* <InputLabel id="demo-simple-select-autowidth-label">{t("language")}</InputLabel> */}
                            <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={destLang}
                            defaultValue={selectableLanguages[0].value}
                            onChange={(event) => { setDestLang(event.target.value); }}
                            autoWidth
                            label={t("language")}
                            >
                            
                            {selectableLanguages.map( (selLang) => {
                                                   return <MenuItem key={selLang.value} value={selLang.value}>{t("tar_lang_" + selLang.name)}</MenuItem>
                                }) }
     
                            </Select>
                        </FormControl>
                        
                        <TextField
                            sx={{ m: 1, minWidth: 80, maxWidth: 450 }} 
                            
                            fullWidth
                            autoComplete="Title"
                            label={t("notification_title")}
                            
                            {...getFieldProps('title')}
                            error={Boolean(touched.title && errors.title)}
                            helperText={touched.title && errors.title}
                        />

                        <TextField
                            fullWidth
                            autoComplete="Body"
                            label={t("notification_body")}
                            minRows={4}
                            multiline
                            {...getFieldProps('body')}
                            error={Boolean(touched.body && errors.body)}
                            helperText={touched.body && errors.body}
                        />



                        <FormControlLabel sx={{m:0}} control={<Checkbox checked={sendTestMessage} onChange={ (event) => { setSendTestMessage(event.target.checked) } } /> } label={t("notification_sendTestMessageDescription")} />

     
                        { sendTestMessage && <Autocomplete
                            multiple
                            id="tags-outlined"
                            options={users}
                            getOptionLabel={(option) => option.Email}
                            defaultValue= {selectedUsersDefaultValue}
                            filterSelectedOptions
                            onChange={(event, newValue) => {
                                setAutoCompleteValue(newValue);
                              }}
                           
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("notification_select_user")}
                                placeholder={t("notification_more_users")}
                            />
                            )} /> }
                    {/* 
                        <FormGroup>
                            <FormControlLabel control={<Checkbox name="getsNotifications"  checked={formik.values.getsNotifications} onChange={formik.handleChange} />  } label="getsNotifications" />
                            <FormControlLabel control={<Checkbox name="isVisibleToOthers"  checked={formik.values.isVisibleToOthers} onChange={formik.handleChange}  />} label="isVisibleToOthers" />
                            <FormControlLabel control={<Checkbox name="ridesVisibleToPublic"  checked={formik.values.ridesVisibleToPublic} onChange={formik.handleChange}   />} label="ridesVisibleToPublic" />

                            <FormControlLabel control={<Checkbox name="enabled"  checked={formik.values.enabled} onChange={formik.handleChange}   />} label="enabled" />
                        </FormGroup> */}



                        <LoadingButton
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                            loading={isSubmitting}>
                            {t("notification_send_message")}
                        </LoadingButton>

                        <Fade in={showServerMessage === true} timeout={ {enter:1000, exit:1000 }}>
                            <div> 
                                <FormHelperText error={serverError}>{serverMessage}</FormHelperText>
                            </div>
                        </Fade>
                    

                        </Stack>
                    </Form>
                </FormikProvider>
            </Container>
        </Page>
    );
}
